import { ProductCheckListDataRow } from '../../types';

export type ProductCheckListTableRow = ProductCheckListDataRow;

export enum ProductCheckListTableColumn {
    Id = 'id',
    Resource = 'resourceId',
    Guests = 'guests',
    Owner = 'owner',
    Notes = 'notes',
    Products = 'productsData',
    AgeCategoryTotal = 'ageCategoryTotal',
    Total = 'total',
    Action = 'action',
}

export enum ProductCheckListRowAction {
    ClaimPerPerson = 'ClaimPerPerson',
    AddProductsToReservation = 'AddProductsToReservation',
    AddProductsToGuests = 'AddProductsToGuests',
    ViewReservation = 'ViewReservation',
    ViewGuest = 'ViewGuest',
}
